import React, { FC } from 'react';
import styles from './ProductCardBanner.module.scss';

interface ProductCardBannerProps {
  text?: string;
  color?: string;
  textColor?: string;
}

const ProductCardBanner: FC<ProductCardBannerProps> = (
  props: ProductCardBannerProps,
) => {
  const { text, color, textColor } = props;

  return (
    <div
      className={styles.Banner}
      style={{ background: color, color: textColor }}
    >
      {text}
    </div>
  );
};

ProductCardBanner.defaultProps = {
  text: '',
  color: '',
  textColor: '',
};

export default ProductCardBanner;
